import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';

import { SuperAdminService } from '../../../super-admin.service';
import { ToastrService } from 'ngx-toastr';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-new-invoice',
  templateUrl: './new-invoice.component.html',
  styleUrls: ['./new-invoice.component.css']
})
export class NewInvoiceComponent implements OnInit {
  checkInvoiceType: any = 'Ad Hoc';
  isAdHoc: boolean = false;
  invtot: any = 0;
  tooltaxPaidtot: any = 0;
  clientName: any;
  extrahour: any = 0;
  kmtot: any = 0;
  totLabourLoad: number = 0;
  totLabourUnload: number = 0;
  totDetention: number = 0;
  vehicles: any;
  clientList = [];
  particlarLR: any;
  users: any = [];
  paramId: any;
  billno: string = '';
  Frieght: number = 0;
  transporterName: string = '';
  transporterAddress: string = '';
  transporterGstNo: string = '';
  totalAmountInAdhoc: number = 0;
  otherPayment: number = 0;
  isEditing: boolean = false;
  isSaving: boolean = false;
  backupUsers: any = [];

  editLR = new FormGroup({
    clientList: new FormControl(''),
    ConsigneeName: new FormControl(''),
    ConsigneeAddress: new FormControl(''),
    ConsignorName: new FormControl(''),
    ConsignorAddress: new FormControl(''),
    VehicleNo: new FormControl(''),
    vehicleType: new FormControl(''),
    from: new FormControl(''),
    to: new FormControl('',),
    GSTIN: new FormControl(''),
    date: new FormControl(''),
    RoadPermitNo: new FormControl(''),
    StateCode: new FormControl(''),
    DLY: new FormControl(''),
    DeclaredValue: new FormControl(''),
    fixAdhoc: new FormControl(''),
    quantity: new FormControl(''),
    transportorName: new FormControl(''),
    transportorMobile: new FormControl(''),
    driverName: new FormControl(''),
    driverMobile: new FormControl(''),
    tollAttachment: new FormControl(''),
    loadingSlipAttchment: new FormControl(''),
    Frieght: new FormControl(''),


    startmeterReading: new FormControl(''),
    endmeterReading: new FormControl(''),
    tripSDate: new FormControl(''),
    tripEDate: new FormControl(''),
    outtime: new FormControl(''),
    INtime: new FormControl(''),
    noofTools: new FormControl(''),
    tooltaxPaid: new FormControl(''),
    labourPaid: new FormControl(''),
    otherPayment: new FormControl(''),
    updownkm: new FormControl(''),
    totalhour: new FormControl(''),
    extrahour: new FormControl(''),
    detention: new FormControl(''),
    advance: new FormControl(''),
    balance: new FormControl(''),
    balancePaid: new FormControl(''),
    vehicleRate: new FormControl(''),
    // clientList: new FormControl('', [Validators.required]),
    LR_no: new FormControl('', [Validators.required]),
    // ConsigneeName: new FormControl('', [Validators.required]),
    // ConsigneeAddress: new FormControl('', [Validators.required]),
    // ConsignorName: new FormControl('', Validators.required),
    // ConsignorAddress: new FormControl('', Validators.required),
    // VehicleNo: new FormControl('', [Validators.required]),
    // from: new FormControl('', Validators.required),
    // to: new FormControl('', Validators.required),
    // GSTIN: new FormControl('', [Validators.required]),
    // date: new FormControl('', Validators.required),

    // startmeterReading: new FormControl(''),
    // endmeterReading: new FormControl(''),
    // outtime: new FormControl(''),
    // INtime: new FormControl(''),
    // noofTools: new FormControl(''),
    // tooltaxPaid: new FormControl(''),
    // labourPaid: new FormControl(''),
    // otherPayment: new FormControl(''),
    // updownkm: new FormControl(''),
    // totalhour: new FormControl(''),
    // vehicleRate: new FormControl('')

    //status: new FormControl('', Validators.required)
  })
  constructor(private activatedRoute: ActivatedRoute,
    private toastr: ToastrService, private router: Router,
    private superAdminService: SuperAdminService) {
    this.activatedRoute.params.subscribe(param => {
      this.paramId = param.id;
      this.getParticularInvoice(this.paramId);
    })
  }



  ngOnInit(): void {
    //this.getParticularInvoice();
  }

  getClientList() {
    this.superAdminService.getClientList()
      .subscribe((res: { status: any, message: any, data: any }) => {

        if (res.status == true) {
          var rawdata = res.data;
          this.clientList = rawdata;
          this.clientName = this.clientList.filter((item) => item._id == this.particlarLR.clientId)[0]['clientName'];
          //this.dtOptions.data = this.users;
        }
        else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl('superAuth/login');
          } else {
            this.toastr.success(res.message);
          }
        }

      }, error => {
      });

  }



  initform() {
    this.editLR.patchValue({
      // Basic Details

      clientList: this.particlarLR.clientName,
      LR_no: this.particlarLR.LR_no,
      //date: this.particlarLR.date,
      ConsigneeName: this.particlarLR.consignee_name,
      ConsigneeAddress: this.particlarLR.consignee_address,
      ConsignorName: this.particlarLR.consignor_name,
      ConsignorAddress: this.particlarLR.consignor_address,
      VehicleNo: this.particlarLR.vehicle_id,
      vehicleType: this.particlarLR.vehicleType,
      //VehicleNo: this.particlarLR.vehicle_no,
      from: this.particlarLR.from,
      to: this.particlarLR.to,
      GSTIN: this.particlarLR.GSTIN,
      date: new Date(this.particlarLR.date).toISOString().split('T')[0],
      RoadPermitNo: this.particlarLR.road_permit_no,
      StateCode: this.particlarLR.stateCode,
      DLY: this.particlarLR.dly_no,
      DeclaredValue: this.particlarLR.declared_value,
      fixAdhoc: this.particlarLR.fixAdhoc,
      quantity: this.particlarLR.quantity,
      transportorName: this.particlarLR.transportorName,
      transportorMobile: this.particlarLR.transportorMobile,
      driverName: this.particlarLR.driverName,
      driverMobile: this.particlarLR.driverMobile,
      Frieght: this.particlarLR.Frieght,

      // Information For office use only

      startmeterReading: this.particlarLR.startmeterReading,
      endmeterReading: this.particlarLR.endmeterReading,
      tripSDate: new Date(this.particlarLR.tripStartDate).toISOString().split('T')[0],
      tripEDate: new Date(this.particlarLR.tripEndDate).toISOString().split('T')[0],
      INtime: this.particlarLR.in_time,
      outtime: this.particlarLR.out_time,
      noofTools: this.particlarLR.noofTools,
      tooltaxPaid: this.particlarLR.tooltaxPaid,
      labourPaid: this.particlarLR.labourPaid,
      otherPayment: this.particlarLR.otherPayment,
      updownkm: this.particlarLR.up_down_km,
      totalhour: this.particlarLR.totalhour,
      extrahour: this.particlarLR.extrahour,
      detention: this.particlarLR.detention,
      advance: this.particlarLR.advance,
      balance: this.particlarLR.balance,
      balancePaid: this.particlarLR.balancePaid,
      vehicleRate: this.particlarLR.vehicleRate,


    })
  }

  getLRDetail(id: string) {
    this.superAdminService.particlarLR(id).subscribe((res: { status: any, message: any, data: any }) => {
      if (res.status == true) {
        this.particlarLR = res.data[0].receipts[0];
        this.vehicles = res.data[0].vehiclesDetail;
        this.getClientList();
        this.superAdminService.getSuperVisorName().subscribe((supervisors: { status: any, message: any, data: any }) => {
          if (supervisors.status == true) {
            var supervisorsData = supervisors.data;
            this.particlarLR.supervisorId = supervisorsData.filter((item) => this.particlarLR.supervisorId == item._id);
            this.particlarLR.supervisorId = this.particlarLR.supervisorId[0] ? this.particlarLR.supervisorId[0]['full_name'] : this.particlarLR.supervisorId[0]
          } else {
            // console.log(res.message);
          }
        }, error => {
          // console.log('error', error);
        })
        this.initform();
      }
      else {
        if (res.status == 401) {
          this.toastr.error(res.message);
          window.sessionStorage.clear();
          this.router.navigateByUrl('superAuth/login');

        } else {
          this.toastr.success(res.message);
        }
      }

    }, error => {
    });

  }
  getParticularInvoice(id: string) {
    this.superAdminService.getParticularInvoice(id)
      .subscribe((res: { status: any, message: any, data: any }) => {
        if (res.status === true) {
          const rawdata = res.data;
          this.billno = rawdata[0]?.billno || rawdata[0]?.billNo || '';

          // Invoice type nikalna
          const rawInvType = rawdata[0]?.invoiceType
            || rawdata[0]?.invoiceTypeName
            || rawdata[0]?.invoice?.[0]?.invoiceTypeName?.[0]
            || rawdata[0]?.invoice?.[0]?.invoiceTypeName
            || rawdata[0]?.invoice?.[0]?.fixAdhoc?.[0]
            || rawdata[0]?.invoice?.[0]?.fixAdhoc
            || rawdata[0]?.fixAdhoc
            || rawdata[0]?.invoice?.[0]?.invoiceType
            || '';

          // Supports both new DB values ('Ad Hoc' / 'Fixed') and legacy values ('Type1' / 'Type2')
          this.isAdHoc = /adhoc/i.test(rawInvType)
            || /ad hoc/i.test(rawInvType)
            || rawInvType === 'Type1'
            || rawInvType === 'Type 1'
            || !rawInvType;

          this.checkInvoiceType = rawInvType || (this.isAdHoc ? 'Ad Hoc' : 'Fixed');

          // Users set karna
          const rawInvoice = rawdata[0]?.invoice || rawdata[0]?.invoiceData;
          if (Array.isArray(rawInvoice)) {
            this.users = rawInvoice;
          } else if (rawInvoice && typeof rawInvoice === 'object') {
            this.users = [rawInvoice];
          } else if (Array.isArray(rawdata[0])) {
            this.users = rawdata[0];
          } else {
            this.users = [];
          }

          // Ensure manual entry arrays are initialized
          this.users.forEach((user: any) => {
            if (!user) return;
            const lrCount = Array.isArray(user.LR_no) ? user.LR_no.length : (user.LR_no ? 1 : 0);
            if (!Array.isArray(user.labourLoad)) user.labourLoad = new Array(lrCount).fill(0);
            if (!Array.isArray(user.labourUnload)) user.labourUnload = new Array(lrCount).fill(0);
            if (!Array.isArray(user.detention)) user.detention = new Array(lrCount).fill(0);
          });

          this.Frieght = Array.isArray(rawdata[0]?.invoice?.[0]?.Frieght)
            ? rawdata[0]?.invoice?.[0]?.Frieght?.[0]
            : (rawdata[0]?.invoice?.[0]?.Frieght || '');

          // Totals calculate karna
          this.recalculateTotals();
          this.loadTransporterDetails();
        } else {
          if (res.status === 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl('superAuth/login');
          } else {
            this.toastr.success(res.message);
          }
        }
      }, error => {
        console.error(error);
      });
  }

recalculateTotals() {
  this.kmtot = 0;
  this.extrahour = 0;
  this.tooltaxPaidtot = 0;
  this.invtot = 0;
  this.totLabourLoad = 0;
  this.totLabourUnload = 0;
  this.totDetention = 0;
  this.Frieght = 0;
  this.otherPayment = 0;

  if (!Array.isArray(this.users)) return;

  this.users.forEach((user: any) => {
    if (!user) return;

    this.invtot += (Array.isArray(user.vehicleRate) ? user.vehicleRate : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.kmtot += (Array.isArray(user.up_down_km) ? user.up_down_km : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.extrahour += (Array.isArray(user.extrahour) ? user.extrahour : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.tooltaxPaidtot += (Array.isArray(user.tooltaxPaid) ? user.tooltaxPaid : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totLabourLoad += (Array.isArray(user.labourLoad) ? user.labourLoad : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totLabourUnload += (Array.isArray(user.labourUnload) ? user.labourUnload : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totDetention += (Array.isArray(user.detention) ? user.detention : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.otherPayment += (Array.isArray(user.otherPayment) ? user.otherPayment : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.Frieght += (Array.isArray(user.Frieght) ? user.Frieght : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);
  });

  console.log('Totals:', {
    Frieght: this.Frieght,
    otherPayment: this.otherPayment,
    invtot: this.invtot,
    totLabourLoad: this.totLabourLoad,
    totLabourUnload: this.totLabourUnload,
    totDetention: this.totDetention
  });

  if (this.isAdHoc) {
    this.totalAmountInAdhoc =
      this.totDetention +
      // this.invtot +
      this.totLabourLoad +
      this.totLabourUnload +
      this.Frieght +
      this.otherPayment;

    console.log('totalAmountInAdhoc:', this.totalAmountInAdhoc);
  }
}


  loadTransporterDetails() {
    const firstUser = this.users[0];
    if (!firstUser) {
      this.transporterName = 'Radha Swami Transport Service';
      this.transporterAddress = 'N/A';
      this.transporterGstNo = 'N/A';
      return;
    }

    const toArray = (val: any): any[] => {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      if (typeof val === 'string' || typeof val === 'number') return [val];
      return [];
    };

    const rawTransporterNames = toArray(firstUser.transportorName);
    const validTransporterName = rawTransporterNames.find((name: any) =>
      name && name !== '0' && name !== '1' && name !== '-' && String(name).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.transportorName === 'string' ? firstUser.transportorName : '') || '';

    const rawGstins = toArray(firstUser.GSTIN);
    const validGstin = rawGstins.find((gst: any) =>
      gst && gst !== '0' && gst !== '1' && gst !== '-' && String(gst).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.GSTIN === 'string' ? firstUser.GSTIN : '') || '';

    const rawAddresses = [
      ...toArray(firstUser.consignor_address),
      ...toArray(firstUser.consignee_address)
    ];
    const validAddress = rawAddresses.find((addr: any) =>
      addr && addr !== '0' && addr !== '1' && addr !== '-' && String(addr).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.consignor_address === 'string' ? firstUser.consignor_address : '')
      || (typeof firstUser.consignee_address === 'string' ? firstUser.consignee_address : '')
      || '';

    this.transporterName = validTransporterName && validTransporterName !== '0' && validTransporterName !== '1'
      ? validTransporterName
      : 'Radha Swami Transport Service';
    this.transporterAddress = validAddress || 'N/A';
    this.transporterGstNo = validGstin && validGstin !== '0' && validGstin !== '1' ? validGstin : 'N/A';

    this.superAdminService.getAllTransporters(1, 1000).subscribe({
      next: (res: any) => {
        if (res?.status && Array.isArray(res?.data) && res.data.length > 0) {
          const list = res.data;

          const matched = list.find((t: any) => {
            const fullName = (t.user_id?.full_name || '').trim().toLowerCase();
            const tpId = (t.transporter_id || '').trim().toLowerCase();
            const gstin = (t.gstin || '').trim().toLowerCase();

            const targetName = String(validTransporterName).trim().toLowerCase();
            const targetGst = String(validGstin).trim().toLowerCase();

            return (targetName && (fullName === targetName || tpId === targetName)) ||
              (targetGst && gstin === targetGst);
          });

          if (matched) {
            this.setTransporterFromRecord(matched);
            return;
          }

          // Check if vehicle connects to a transporter
          const vehicleNo = Array.isArray(firstUser.vehicle_id) ? firstUser.vehicle_id[0] : firstUser.vehicle_id;
          if (vehicleNo) {
            this.superAdminService.getvehicles().subscribe({
              next: (vRes: any) => {
                if (vRes?.status && Array.isArray(vRes?.data)) {
                  const matchedVehicle = vRes.data.find((v: any) => v.vehicle_no === vehicleNo);
                  if (matchedVehicle && matchedVehicle.transporter) {
                    const t = list.find((item: any) => item._id === matchedVehicle.transporter);
                    if (t) {
                      this.setTransporterFromRecord(t);
                    }
                  }
                }
              },
              error: (err: any) => {
                console.warn("Could not load vehicles for transporter lookup:", err);
              }
            });
          }
        }
      },
      error: (err: any) => {
        console.warn("Error loading transporters:", err);
      }
    });
  }

  private setTransporterFromRecord(t: any) {
    if (t.user_id?.full_name) {
      this.transporterName = t.user_id.full_name;
    }
    if (t.gstin) {
      this.transporterGstNo = t.gstin;
    }
    const addressParts = [
      t.address_line_1,
      t.address_line_2,
      t.city,
      t.state,
      t.pin_code
    ].filter((part: any) => part && String(part).trim().length > 0);

    if (addressParts.length > 0) {
      this.transporterAddress = addressParts.join(', ');
    }
  }

  getFreight(user: any, i: number): string {
    if (user?.Frieght && user.Frieght[i] !== undefined && user.Frieght[i] !== null && user.Frieght[i] !== '') {
      return user.Frieght[i];
    }
    if (user?.freight && user.freight[i] !== undefined && user.freight[i] !== null && user.freight[i] !== '') {
      return user.freight[i];
    }
    return '-';
  }

  getAdhocLineAmount(user: any, index: number): number {
    const amount = (value: any) => Number(Array.isArray(value) ? value[index] || 0 : value || 0);
    return amount(user?.Frieght ?? user?.freight)
      + amount(user?.labourLoad)
      + amount(user?.labourUnload)
      + amount(user?.otherPayment)
      + amount(user?.detention);
  }

  getVehicleType(user: any, i: number): string {
    return user?.vehicle_type?.[i] || user?.vehicleType?.[i] || '-';
  }

  enableEdit() {
    this.backupUsers = JSON.parse(JSON.stringify(this.users));
    this.isEditing = true;
  }

  cancelEdit() {
    if (this.backupUsers && this.backupUsers.length > 0) {
      this.users = JSON.parse(JSON.stringify(this.backupUsers));
    }
    this.isEditing = false;
    this.recalculateTotals();
  }

  saveEdit() {
    const updateObservables: any[] = [];

    this.users.forEach((user: any) => {
      const lrCount = (user.LR_no || []).length;
      for (let i = 0; i < lrCount; i++) {
        const lrId = user._id?.[i];
        if (lrId) {
          const payload = {
            labourLoad: Number(user.labourLoad?.[i] || 0),
            labourUnload: Number(user.labourUnload?.[i] || 0),
            detention: Number(user.detention?.[i] || 0)
          };
          updateObservables.push(this.superAdminService.updateLRManualCharges(lrId, payload));
        }
      }
    });

    if (updateObservables.length === 0) {
      this.isEditing = false;
      return;
    }

    this.isSaving = true;
    forkJoin(updateObservables).subscribe({
      next: () => {
        this.isSaving = false;
        this.isEditing = false;
        this.toastr.success("Invoice charges updated successfully");
        this.recalculateTotals();
      },
      error: (err: any) => {
        this.isSaving = false;
        this.toastr.error(err?.error?.message || err?.message || "Failed to update charges");
      }
    });
  }




  sendInvoice(divName) {
    var data = document.getElementById(divName);
    html2canvas(data).then(canvas => {
      var imgWidth = 208;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png', 0.3)
      let pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(contentDataURL, 'PNG', 1, 1, imgWidth, imgHeight, undefined, 'FAST');
      let binary = pdf.output();
      binary = binary ? btoa(binary) : '';
      this.superAdminService.sendInvoice(this.paramId, binary).subscribe((res: any) => {
        if (res.status == true) {
          this.toastr.success(res.message);
        }
        else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl('superAuth/login');

          } else {
            this.toastr.error(res.message);
          }
        }
      }, error => {
        console.log(error);
      });
    });

  }
  backTo() {
    window.history.back()
  }

}
